'use strict';

angular.module('cloudBillingLegacyFrontend').directive('eaWidgetGroupFilterListViewPgTemplateHost', function($compile) {
  return {
    restrict: 'C',
    scope: {
      template: '='
    },
    link: function(scope, element) {
      element.attr('class', scope.template);
      $compile(element)(scope.$parent);
    }
  };
});
